import { HexColorPicker } from 'react-colorful'
import { useState } from 'react'

function PxSlider({ label, value, onChange, max = 40 }) {
  const numVal = parseInt(value) || 0
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <span style={{ fontSize: '0.7rem', color: '#64748b', width: '38px', flexShrink: 0 }}>{label}</span>
      <input
        type="range"
        min="0"
        max={max}
        step="1"
        value={numVal}
        onChange={(e) => onChange(`${e.target.value}px`)}
        style={{ flex: 1, cursor: 'pointer', height: '4px' }}
      />
      <span style={{ fontSize: '0.7rem', color: '#94a3b8', width: '34px', textAlign: 'right', flexShrink: 0 }}>{numVal}px</span>
    </div>
  )
}

function MarginSlider({ label, value, onChange }) {
  const numVal = parseInt(value) || 0
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <span style={{ fontSize: '0.7rem', color: '#64748b', width: '38px', flexShrink: 0 }}>{label}</span>
      <input
        type="range"
        min="0"
        max="20"
        step="1"
        value={numVal}
        onChange={(e) => onChange(`${e.target.value}%`)}
        style={{ flex: 1, cursor: 'pointer', height: '4px' }}
      />
      <span style={{ fontSize: '0.7rem', color: '#94a3b8', width: '30px', textAlign: 'right', flexShrink: 0 }}>{numVal}%</span>
    </div>
  )
}

export default function ButtonSettings({ block, onUpdate }) {
  const { settings } = block
  const [showTextColorPicker, setShowTextColorPicker] = useState(false)
  const [showBgColorPicker, setShowBgColorPicker] = useState(false)

  const updatePadding = (side, value) => {
    onUpdate({ padding: { ...settings.padding, [side]: value } })
  }

  const updateMargin = (side, value) => {
    onUpdate({ margin: { ...settings.margin, [side]: value } })
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <h4 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>Button Content</h4>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Button Text
        </label>
        <input
          type="text"
          value={settings.text || ''}
          onChange={(e) => onUpdate({ text: e.target.value })}
          placeholder="Click Here"
          style={{ width: '100%', fontSize: '0.85rem', padding: '0.5rem' }}
        />
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Link URL
        </label>
        <input
          type="text"
          value={settings.link || ''}
          onChange={(e) => onUpdate({ link: e.target.value })}
          placeholder="https://example.com"
          style={{ width: '100%', fontSize: '0.85rem', padding: '0.5rem' }}
        />
      </div>

      <h4 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>Button Style</h4>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Width
        </label>
        <select
          value={settings.width === 'auto' ? 'auto' : settings.width === '100%' ? 'full' : 'custom'}
          onChange={(e) => {
            if (e.target.value === 'auto') onUpdate({ width: 'auto' })
            else if (e.target.value === 'full') onUpdate({ width: '100%' })
            else onUpdate({ width: '50%' })
          }}
          style={{ width: '100%', fontSize: '0.85rem', padding: '0.4rem' }}
        >
          <option value="auto">Auto (fit content)</option>
          <option value="full">Full Width (100%)</option>
          <option value="custom">Custom</option>
        </select>
        {settings.width !== 'auto' && settings.width !== '100%' && (
          <div style={{ marginTop: '0.5rem' }}>
            <input
              type="range"
              min="20"
              max="100"
              step="5"
              value={parseInt(settings.width) || 50}
              onChange={(e) => onUpdate({ width: `${e.target.value}%` })}
              style={{ width: '100%', cursor: 'pointer' }}
            />
            <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>{settings.width}</span>
          </div>
        )}
      </div>

      <div style={{ position: 'relative' }}>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Button Color
        </label>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <div
            onClick={() => setShowBgColorPicker(!showBgColorPicker)}
            style={{
              width: '36px',
              height: '32px',
              backgroundColor: settings.backgroundColor || '#007bff',
              border: '1px solid var(--color-border)',
              borderRadius: '6px',
              cursor: 'pointer',
              boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.05)'
            }}
          />
          <input
            type="text"
            value={settings.backgroundColor || ''}
            onChange={(e) => onUpdate({ backgroundColor: e.target.value })}
            onBlur={(e) => {
              if (!e.target.value.trim()) onUpdate({ backgroundColor: '#007bff' })
            }}
            placeholder="#007bff"
            style={{ flex: 1, fontSize: '0.85rem', padding: '0.4rem' }}
          />
        </div>
        {showBgColorPicker && (
          <div style={{ position: 'absolute', zIndex: 10, marginTop: '0.5rem' }}>
            <div style={{ position: 'fixed', inset: 0 }} onClick={() => setShowBgColorPicker(false)} />
            <HexColorPicker
              color={settings.backgroundColor || '#007bff'}
              onChange={(color) => onUpdate({ backgroundColor: color })}
            />
          </div>
        )}
      </div>

      <div style={{ position: 'relative' }}>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Text Color
        </label>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <div
            onClick={() => setShowTextColorPicker(!showTextColorPicker)}
            style={{
              width: '36px',
              height: '32px',
              backgroundColor: settings.color || '#ffffff',
              border: '1px solid var(--color-border)',
              borderRadius: '6px',
              cursor: 'pointer',
              boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.05)'
            }}
          />
          <input
            type="text"
            value={settings.color || ''}
            onChange={(e) => onUpdate({ color: e.target.value })}
            onBlur={(e) => {
              if (!e.target.value.trim()) onUpdate({ color: '#ffffff' })
            }}
            placeholder="#ffffff"
            style={{ flex: 1, fontSize: '0.85rem', padding: '0.4rem' }}
          />
        </div>
        {showTextColorPicker && (
          <div style={{ position: 'absolute', zIndex: 10, marginTop: '0.5rem' }}>
            <div style={{ position: 'fixed', inset: 0 }} onClick={() => setShowTextColorPicker(false)} />
            <HexColorPicker
              color={settings.color || '#ffffff'}
              onChange={(color) => onUpdate({ color })}
            />
          </div>
        )}
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Font Size
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <input
            type="range"
            min="10"
            max="32"
            value={parseInt(settings.fontSize) || 16}
            onChange={(e) => onUpdate({ fontSize: `${e.target.value}px` })}
            style={{ flex: 1 }}
          />
          <span style={{ fontSize: '0.75rem', color: '#64748b', minWidth: '36px', textAlign: 'right' }}>
            {parseInt(settings.fontSize) || 16}px
          </span>
        </div>
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Alignment
        </label>
        <div style={{ display: 'flex', gap: '0.35rem' }}>
          {['left', 'center', 'right'].map(align => (
            <button
              key={align}
              onClick={() => onUpdate({ textAlign: align })}
              style={{
                flex: 1,
                padding: '0.4rem',
                fontSize: '0.7rem',
                textTransform: 'capitalize',
                border: `1.5px solid ${settings.textAlign === align ? 'var(--color-primary)' : '#e2e8f0'}`,
                borderRadius: '6px',
                background: settings.textAlign === align ? 'rgba(99,102,241,0.06)' : '#fff',
                color: settings.textAlign === align ? 'var(--color-primary)' : '#475569',
                cursor: 'pointer',
                fontWeight: settings.textAlign === align ? '600' : '400'
              }}
            >
              {align}
            </button>
          ))}
        </div>
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Border Radius
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <input
            type="range"
            min="0"
            max="30"
            value={parseInt(settings.borderRadius) || 0}
            onChange={(e) => onUpdate({ borderRadius: `${e.target.value}px` })}
            style={{ flex: 1 }}
          />
          <span style={{ fontSize: '0.75rem', color: '#64748b', minWidth: '36px', textAlign: 'right' }}>
            {parseInt(settings.borderRadius) || 0}px
          </span>
        </div>
      </div>

      <h4 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>Spacing</h4>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Button Padding
        </label>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
          <PxSlider label="Top" value={settings.padding?.top} onChange={(v) => updatePadding('top', v)} />
          <PxSlider label="Right" value={settings.padding?.right} onChange={(v) => updatePadding('right', v)} max={60} />
          <PxSlider label="Bottom" value={settings.padding?.bottom} onChange={(v) => updatePadding('bottom', v)} />
          <PxSlider label="Left" value={settings.padding?.left} onChange={(v) => updatePadding('left', v)} max={60} />
        </div>
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Outer Margin
        </label>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
          <MarginSlider label="Top" value={settings.margin?.top} onChange={(v) => updateMargin('top', v)} />
          <MarginSlider label="Bottom" value={settings.margin?.bottom} onChange={(v) => updateMargin('bottom', v)} />
        </div>
      </div>
    </div>
  )
}
